import WidgetContainer from './WidgetContainer';

export default WidgetContainer;
